// Symbol configuration
export const SYMBOLS = {
  XAUUSD: {
    name: '现货黄金',
    code: 'XAUUSD',
    decimals: 2,
    spread: 20,
    vol24h: 12580,
    marginPerLot: 1000,
    defaultPrice: 4330.84
  },
  XAGUSD: {
    name: '现货白银',
    code: 'XAGUSD',
    decimals: 3,
    spread: 30,
    vol24h: 8430,
    marginPerLot: 1000,
    defaultPrice: 40.125
  },
  USDX: {
    name: '美元指数',
    code: 'USDX',
    decimals: 2,
    spread: 1,
    vol24h: 0,
    marginPerLot: 1000,
    defaultPrice: 98.60
  }
}

// Period intervals for KLineCharts
export const PERIOD_INTERVAL = {
  '1m': 1,
  '5m': 5,
  '15m': 15,
  '30m': 30,
  '1h': 60,
  '4h': 240,
  '1d': 1440
}

// Indicator name mapping for KLineCharts
export const INDICATOR_MAP = {
  ma: 'MA',
  macd: 'MACD',
  boll: 'BOLL'
}

// Exchange rate
export const EXCHANGE_RATE = 1

// Chat replies
export const CHAT_REPLIES = {
  '如何入金': '入金流程：复制平台USDT-TRC20地址 → 从您的钱包转入 → 提交入金申请 → 审核通过后到账。最低入金 10 USDT。',
  '如何出金': '出金流程：进入"出金"页面 → 填写收款地址和金额 → 输入交易密码确认 → 审核通过后1-2小时内到账。',
  '杠杆说明': `当前杠杆为 1:{leverage}，1手保证金 = 1000/{leverage} USDT。杠杆越高，所需保证金越少，但风险也越大，请合理控制仓位。`
}
